import { ChangeEvent, FC, useCallback } from 'react';
import {
  FormControl,
  FormControlLabel,
  FormHelperText,
  InputLabel,
  Radio,
  RadioGroup,
} from '@mui/material';
import cn from 'classnames';

import { IFormRadioProps } from './FormRadio.interface';

import './styles.scss';

const FormRadio: FC<IFormRadioProps> = ({
  className,
  label,
  required,
  input: { name, onChange, value },
  meta,
  options,
}) => {
  const handleChange = useCallback(
    (event: ChangeEvent<HTMLInputElement>, value: string) => {
      // Unfortunately Radio returns selected option's id as string, so we have to convert it back to number manually
      onChange(+value);
    },
    [onChange],
  );

  return (
    <FormControl className={cn('form-radio', className)}>
      {label && (
        <InputLabel
          className="form-radio__label"
          error={meta.error && meta.touched}
          required={required}
        >
          {label}
        </InputLabel>
      )}

      <RadioGroup name={name} value={value} onChange={handleChange}>
        {options.map(item => (
          <FormControlLabel
            control={<Radio />}
            className="form-radio__option"
            key={item.id}
            value={item.id}
            label={item.name}
          />
        ))}
      </RadioGroup>

      {meta.error && meta.touched && <FormHelperText error>{meta.error}</FormHelperText>}
    </FormControl>
  );
};

export default FormRadio;
